// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import { store } from './store/store'
import axios from 'axios'
import VModal from 'vue-js-modal'
import VueNotie  from 'vue-notie'
import * as ModalDialogs from 'vue-modal-dialogs'

Vue.use(ModalDialogs);

Vue.use(VueNotie);
Vue.use(VModal , {dynamic : true})

Vue.config.productionTip = false;
Vue.config.errorHandler = function (err , vm , info) {
  console.log(vm , err , info);
}

const SunnyFactory =""
  + "   _____                         ______           __\n"
  + "  / ___/__  ______  ____  __  __/ ____/___ ______/ /_____  _______  __\n"
  + "  \\__ \\/ / / / __ \\/ __ \\/ / / / /_  / __ `/ ___/ __/ __ \\/ ___/ / / /\n"
  + " ___/ / /_/ / / / / / / / /_/ / __/ / /_/ / /__/ /_/ /_/ / /  / /_/ /\n"
  + "/____/\\__,_/_/ /_/_/ /_/\\__, /_/    \\__,_/\\___/\\__/\\____/_/   \\__, /\n"
  + "                       /____/                                /____/";
console.log('%c'+SunnyFactory+'', 'color:green');


Vue.prototype.$http = axios


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js